export const TWIN_SEQUENCE = {
	ingestSeconds: 10,
	cycleSeconds: 24,
	totalSeconds: 34,
	reducedMotionSeconds: 23,
} as const;

const EPOCH_KEY = "__mlxTwinSequenceEpoch";

declare global {
	interface Window {
		__mlxTwinSequenceEpoch?: number;
	}
}

export function normaliseTwinSequenceTime(nowMs: number, epochMs: number) {
	const elapsedSeconds = Math.max(0, nowMs - epochMs) / 1000;
	return elapsedSeconds % TWIN_SEQUENCE.totalSeconds;
}

export function getTwinSequenceTime(nowMs = performance.now()) {
	window[EPOCH_KEY] ??= nowMs;
	return normaliseTwinSequenceTime(nowMs, window[EPOCH_KEY]);
}
